import {
  EntityLinks,
  Goal,
  GoalFilterDocument,
  GoalType,
  Timestamp,
  WeekDays,
} from '@griply/types';

import { filterGoalsByFilterDocument } from './filter-goals-by-filter-document';
import { filterGoalsByType } from './filter-goals-by-type';
import {
  filterRoadmapGoals,
  RoadmapGoalFilterSettings,
} from './filter-roadmap-goals';

export type FilterRoadmapOverviewGoalsOptions = {
  roadmapSettings?: RoadmapGoalFilterSettings | null;
  showCompleted: boolean;
  goalTypes: GoalType[];
  filterDocument?: GoalFilterDocument;
  links: EntityLinks;
  today: Timestamp;
  weekStartsOn: WeekDays;
};

export const filterRoadmapOverviewGoals = (
  goals: Goal[],
  {
    roadmapSettings,
    showCompleted,
    goalTypes,
    filterDocument,
    links,
    today,
    weekStartsOn,
  }: FilterRoadmapOverviewGoalsOptions,
): Goal[] => {
  // Type-filter after: the archived/completed walk needs parents a type filter drops.
  const roadmapFiltered = filterGoalsByType(
    filterRoadmapGoals(
      goals,
      { ...roadmapSettings, hideCompletedGoals: !showCompleted },
      links,
    ),
    goalTypes,
  );

  if (!filterDocument) {
    return roadmapFiltered;
  }

  return filterGoalsByFilterDocument(roadmapFiltered, filterDocument, {
    links,
    today,
    weekStartsOn,
  });
};
